import { fetchApi } from '@/config/axiosSetting';
import {
  GetVehicleModelQueryParamsType,
  GetVehicleModelQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVehicleModel/getVehicleModelQuery.type';

export const getVehicleModelFunction = (
  params: GetVehicleModelQueryParamsType,
): Promise<GetVehicleModelQueryResponseType> => {
  const url = () => {
    switch (params.participantRoleType) {
      case 'damaged':
      case 'culprit':
        return `property/reports/${params?.id}/accident_users/${params?.participantRoleType}/vehicle_model/`;
      case 'initial':
        return `initial/reports/${params?.id}/vehicle_model/`;
      case 'body':
        return `body/reports/${params?.id}/vehicle_model/`;
      default:
        return '';
    }
  };
  return fetchApi.get(url(), { params: { damaged_id: params.damaged_id } });
};
